import { useTranslation } from 'react-i18next';

import {
  IOrganizationUsersRoleFilter,
  useOrganizationUsersRoleFilter,
  useUpdateOrganizationUsersRoleFilter,
} from '../../../../../../../../features/organization';
import { Filter, IFilterProps } from '../../../../../../filter';

export const RoleFilter = () => {
  const { t } = useTranslation();
  const updateOrganizationUsersRoleFilter = useUpdateOrganizationUsersRoleFilter();
  const filters = useOrganizationUsersRoleFilter();

  const buttonProps: IFilterProps['button'] = {
    text: t('organization.users.filter.role'),
    filters,
    getText: (keys: string[]) => {
      if (keys.length > 1) {
        return t('organization.users.filter.active', { length: keys.length });
      }

      return t(`common.role.${keys[0]}`);
    },
  };

  const popoverProps: IFilterProps['popover'] = {
    clearText: t('organization.users.filter.clear'),
    filters,
    getFilterText: (key) => t(`common.role.${key}`),
    onChange: (filters) => updateOrganizationUsersRoleFilter(filters as IOrganizationUsersRoleFilter),
    onClear: updateOrganizationUsersRoleFilter,
  };

  return <Filter button={buttonProps} popover={popoverProps} />;
};
